import * as React from 'react';

import { PropertyTripSummary } from '@shared-ui/lodging-property-offers/';

import { UitkSpacing } from 'uitk-react-spacing';

import { SharedUiWrapperProps, withSharedUiPropertyOffers } from './shared-ui-property-offers';

const TripSummaryWrapper: React.FC<SharedUiWrapperProps> = ({ data, inputs }) => (
  <UitkSpacing margin={{ blockstart: 'three' }}>
    <PropertyTripSummary data={data} inputs={inputs} />;
  </UitkSpacing>
);

TripSummaryWrapper.displayName = 'SharedUiTripSummary';

export const SharedUiTripSummaryWrapper = withSharedUiPropertyOffers(TripSummaryWrapper);
